import axios from 'axios'
import {
    CommonFilterModel,
    CommonParams,
    CommonParamsWithQuery
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    ConfigurationPersonnelCreateRequest, ConfigurationPersonnelPatchInBatchRequest,
    ConfigurationPersonnelResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationPersonnelService {
    async create(request: ConfigurationPersonnelCreateRequest): Promise<ConfigurationPersonnelResponse> {
        const response = await axios.post<ConfigurationPersonnelResponse>(`/configuration/personnel`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationPersonnelResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelResponse>>(`/configuration/personnel`, { ...filterModel }, { params })
        return response.data
    }

    async get(personnelId: number): Promise<ConfigurationPersonnelResponse> {
        const response = await axios.get<ConfigurationPersonnelResponse>(`/configuration/personnel/${personnelId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/personnel/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationPersonnelPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/personnel/batch`, request)
        return response.data
    }

    async search(params?: CommonParamsWithQuery): Promise<IResponseAgGrid<ConfigurationPersonnelResponse>> {
        const response = await axios.get<IResponseAgGrid<ConfigurationPersonnelResponse>>(`/configuration/personnel/search`, { params })
        return response.data
    }
}

export const configurationPersonnelService = new ConfigurationPersonnelService()
